
import { twMerge } from 'tailwind-merge';
import styles from './Separator.module.css';

interface Props {
    className?: string
}

const Separator = ({ className }: Props) => {

    const classNames = twMerge(className, styles.Separator)

    return (
        <hr className={classNames} />
    )
}

export default Separator;
